import { Route } from 'vue-router';

/**
 *
 * @param route vue-router route
 * @param key key of query to search for
 * 
 * Return the 1st found value of key in route.query object.
 */
export function getValueFromRouteQuery(
  route: Route,
  key: string,
): string | undefined {
  const value = route.query[key];
  if (Array.isArray(value)) {
    for (const el of value) {
      if (!!el) {
        return el;
      }
    }
  }
  if (typeof value === 'string') return value;
  return undefined;
}
